import client from "./client";
import LocalStorage from 'Core/commons/LocalStorage';
import { debounce } from "lodash";

export default {
    namespaced: true,
    state() {
        return {
            ...client.state(),
            corpName: null,
        }
    },
    getters: {
        ...client.getters,
        corpName: state => {
            return state.corpName
        }
    },
    mutations: {
        ...client.mutations,
        setCorpName(state, payload) {
            state.corpName = payload;
        },
    },
    actions: {
        ...client.actions,
        computeCart: () => {
            // In public mode, we can't call compute.
        }
    },
}